export default __webpack_public_path__ + "static/media/cashew-1.2c915fe0.png";